import Vue from 'vue';
import Router from 'vue-router';
import Illegal from './views/Illegal.vue';
import IllegalPay from './views/IllegalPay.vue';
import Ticket from './views/Ticket.vue';
import TicketPay from './views/TicketPay.vue';
import CreateOrder from './views/CreateOrder.vue';
import User from './views/User.vue';
import CarList from './views/CarList.vue';
import CarInfo from './views/CarInfo.vue';
import Agreement from './views/Agreement.vue';
import Login from './views/Login.vue';
import Order from './views/Order.vue';
import AddCar from './views/AddCar.vue';
import Success1 from './views/Success1.vue';
import Success2 from './views/Success2.vue';
import Detail1 from './views/Detail1.vue';
import Detail2 from './views/Detail2.vue';
import Help from './views/Help.vue';
import CouponNow from './views/CouponNow.vue';
import FormWrap from './views/FormWrap.vue';
import OrderModify from './views/OrderModify.vue';
import DontHandle from './views/DontHandle.vue';
import IndexAbchina from './views/IndexAbchina.vue';


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'illegal',
      component: Illegal,
    },
    {
      path: '/illegalPay',
      name: 'illegalPay',
      component: IllegalPay,
    },
    {
      path: '/success1',
      name: 'success1',
      component: Success1,
    },
    {
      path: '/success2',
      name: 'success2',
      component: Success2,
    },
    {
      path: '/detail1',
      name: 'detail1',
      component: Detail1,
    },
    {
      path: '/detail2',
      name: 'detail2',
      component: Detail2,
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: Ticket,
    },
    {
      path: '/pay',
      name: 'ticket',
      component: Ticket, //兼容uc直接缴费跳转
    },
    {
      path: '/ticketPay',
      name: 'ticketPay',
      component: TicketPay,
    },
    {
      path: '/createOrder',
      name: 'createOrder',
      component: CreateOrder,
    },
    {
      path: '/user',
      name: 'user',
      component: User,
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
    },
    {
      path: '/orderModify',
      name: 'orderModify',
      component: OrderModify,
    },
    {
      path: '/carList',
      name: 'carList',
      component: CarList,
    },
    {
      path: '/carInfo',
      name: 'carInfo',
      component: CarInfo,
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: Agreement,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/addcar',
      name: 'addcar',
      component: AddCar,
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
    },
    {
      path: '/couponNow',
      name: 'couponNow',
      component: CouponNow,
    },
    {
      path: '/donthandle',
      name: 'DontHandle',
      component: DontHandle,
    },
    {
      path: '/IndexAbchina',
      name: 'IndexAbchina',
      component: IndexAbchina    
    },
    {
      path: '/formWrap',
      name: 'formWrap',
      component: FormWrap,
      // redirect: '/formWrap/ticketPay',
      children: [
        {
          path: '/formWrap/couponNow',
          name: 'formWrap/couponNow',
          component: CouponNow,
        },
        {
          path: '/formWrap/ticketPay',
          name: 'formWrap/ticketPay',
          component: TicketPay,
        },
        {
          path: '/formWrap/createOrder',
          name: 'formWrap/createOrder',
          component: CreateOrder,
        },
        {
          path: '/formWrap/illegalPay',
          name: 'formWrap/illegalPay',
          component: IllegalPay,
        },
      ],
    },

  ],
});
